import { DEFAULT_CURRENCY, getCurrency } from '../../../utils/currency';

/** Un ticket tiene una sola moneda: la del precio de los productos que lleva (el backend lo valida igual). */
export const ticketCurrency = (items) => getCurrency(items?.[0]?.priceCurrency || DEFAULT_CURRENCY).code;

export const productCurrency = (product) => getCurrency(product?.priceCurrency || DEFAULT_CURRENCY).code;

/** Se puede agregar al ticket si está vacío o el producto está en la misma moneda que el resto. */
export const canAddToTicket = (items, product) => !items?.length || productCurrency(product) === ticketCurrency(items);

export const MIXED_CURRENCY_MESSAGE = 'Un ticket solo puede tener productos en una moneda. Cerrá o vaciá el ticket actual para vender productos en otra moneda.';
